module.exports = __webpack_public_path__ + "img/photo-20.bc04f5cf.png";